import React from 'react'
import { CardBrand } from '../../types/paymentMethod'
import {
  AmexCardIcon,
  DinersClubCardIcon,
  DiscoverCardIcon,
  JCBCardIcon,
  MasterCardIcon,
  UnionPayCardIcon,
  VisaCardIcon,
  CardIcon,
  AmexCardWhiteIcon,
  DiscoverCardWhiteIcon,
  MasterCardWhiteIcon,
  VisaCardWhiteIcon,
} from './card'
import { DinersClubCardWhiteIcon } from './card/DinersClubCardWhiteIcon'
import { JCBCardWhiteIcon } from './card/JCBCardWhiteIcon'
import { UnionPayCardWhiteIcon } from './card/UnionPayCardWhiteIcon'

const CARD_BRAND_ICON_MAP = new Map<string, Function>([
  [CardBrand.AMEX, AmexCardIcon],
  [CardBrand.DINERS_CLUB, DinersClubCardIcon],
  [CardBrand.DISCOVER, DiscoverCardIcon],
  [CardBrand.JCB, JCBCardIcon],
  [CardBrand.MASTERCARD, MasterCardIcon],
  [CardBrand.UNION_PAY, UnionPayCardIcon],
  [CardBrand.VISA, VisaCardIcon],
])

const CARD_BRAND_WHITE_ICON_MAP = new Map<string, Function>([
  [CardBrand.AMEX, AmexCardWhiteIcon],
  [CardBrand.DINERS_CLUB, DinersClubCardWhiteIcon],
  [CardBrand.DISCOVER, DiscoverCardWhiteIcon],
  [CardBrand.JCB, JCBCardWhiteIcon],
  [CardBrand.MASTERCARD, MasterCardWhiteIcon],
  [CardBrand.UNION_PAY, UnionPayCardWhiteIcon],
  [CardBrand.VISA, VisaCardWhiteIcon],
])

export interface CardBrandIconProps {
  brand: string // leave this as a generic string to allow unsupported brands to default to CardIcon
  height?: string
  width?: string
  isLightIcon?: boolean
}

// TODO: Make the icon scalable based on the parent container so we don't have to pass dimensions
// https://stackoverflow.com/questions/9566792/scale-svg-to-container-without-mask-crop
const CardBrandIcon = (props: CardBrandIconProps) => {
  const { brand, isLightIcon, height = '30', width = '30' } = props
  const cardMap = isLightIcon ? CARD_BRAND_WHITE_ICON_MAP : CARD_BRAND_ICON_MAP
  const BrandedIcon = cardMap.get(brand)

  return BrandedIcon ? BrandedIcon({ height, width }) : <CardIcon />
}

export default CardBrandIcon
